import React from 'react';
import about from '../img/about.jpg';
import translate from "../Translation/i18nProvider/translate";

function ImageSection() {
    return (
        <div className="ImageSection">
            <div className="img">
                <img src={about} alt="My img"/>
            </div>
            <div className="about-info">
                <h4>{translate('introducing_im')} {translate('introducing_name')}</h4>
                <p className="about-text">
                    {translate('introducing_bio')}
                </p>
                <div className="about-details">
                    <div className="left-section">
                        <p>{translate('about_img_section_fullname')}</p>
                        <p>{translate('about_img_section_age')}</p>
                        <p>{translate('about_img_section_nationality')}</p>
                        <p>{translate('about_img_section_languages')}</p>
                        <p>{translate('about_img_section_address')}</p>
                        <p>{translate('about_img_section_countries')}</p>
                    </div>
                    <div className="right-section">
                        <p>: {translate('about_img_section_fullname_r')}</p>
                        <p>: {translate('about_img_section_age_r')}</p>
                        <p>: {translate('about_img_section_nationality_r')}</p>
                        <p>: {translate('about_img_section_languages_r')} </p>
                        <p>: {translate('about_img_section_address_r')}</p>
                        <p>: {translate('about_img_section_countries_r')}</p>
                    </div>
                </div>
                <a target="_blank" rel="noreferrer" href="MishaHubka_CV.pdf" download>
                                  <button className="btn">{translate('about_img_section_CV')}</button> </a>
            </div>
        </div>
    )
}

export default ImageSection;
